module.exports = __webpack_public_path__ + "img/tg-round-icon.05928a73.svg";